module.exports = __webpack_public_path__ + "images/selfie-star-a225f1ff7054bc0534bd0f447c634db5.png";